export default "__VITE_ASSET__DR7h1Kd2__"